export default __webpack_public_path__ + "static/char-s-36-zh-Hant-eff3fdcecf06e2c9198c95601f42a177.png";